import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { addSubjectsModel, addSubSecModel } from "../../../../../components/dataAnalytics/dataAnalytics.model";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any

@Component({
  selector: 'addSubjectsS',
  templateUrl: 'addSubjectsS.component.html',
  styleUrls: ['addSubjectsS.component.scss'],

})
export class AddSubjectsSComponent implements OnInit {

  AddSubjectsModel = new addSubjectsModel();
  UpdateSubjectsModel = new addSubjectsModel();
  AddSubSecModel = new addSubSecModel();
  display = "none";
  display1 = "none"
  public schoolId: any;
  public data: any = [];
  public userdetailes = [];
  public mappedData: any;
  public newSectionArray = [];
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public selectAllSectionFlag: boolean;
  public selectedStd = [];
  public selectedStd1 = [];
  public guru: any = [];
  public subName: any;
  public subId: any;
  public payload: any;
  public Gs: any;
  public Es: boolean = false;
  public selectSectionCount: number = 0;
  public standardName: any;
  public sectionName: any;
  public guru1: any = [];
  public ShowSubjectSecData: any = [];
  public showdata: any = [];
  public showdata1: any = [];
  public view: boolean = false;
  public Subjectid: any;
  public Subjectname: any;
  public userId :string;
  public BranchId :string;

  public level: any;
  public ShowLevelData: any;
  public selectedlevel: any;
  public selectedGrade: any;

  collection = 0;



  loading = "none";
  public selectedLevels: any;
  LevelsData: any = [];
  allChecked = false;

  constructor(private dataAnalyticsService: DataAnalyticsService, private messageService: MessageService,
              private noticeboardService: NoticeboardService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
  ) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.userId = this.localStorage.retrieve('id');
    this.BranchId = this.localStorage.retrieve('branchid');

  }

  ngOnInit() {
    this.getLevelsName();
    // this.GetLevelStandardSectionMapping();
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');
    if (this.adminUserFlag || this.schoolUserFlag) {
      this.getClassSection();
      this.getLevels();

    }

    else {
    }
    this.selectedStd = new Array<string>();

    if (this.adminUserFlag == true) {
      this.schoolUserFlag = false;
    }
  }

  checkAll() {
    this.allChecked = this.mappedData.every(std => std.checked);
  }

  //----------------------------------------------Get grades------------------------------------------------

  private GetLevelStandardSectionMapping(selectedlevel: any){
    this.dataAnalyticsService.getGradeLevel(this.selectedlevel).finally(() => { }).subscribe(
      response => {
        this.level = response;
        console.log('grade',this.level)
        try {
          this.selectedGrade = 'Select Grade';
        } catch (error) {
        }
      },
      error => {
        this.level = [];
        console.error(error);
        console.log('grade',this.level)
      });
  };



  //----------------------------------------------Get levels------------------------------------------------
  private getLevelsName() {
    this.dataAnalyticsService.getLevel()._finally(() => { }).subscribe(
      response => {
        this.ShowLevelData = response;
        try {
          this.selectedlevel = 'Select Level';
        } catch (error) {
        }
      }
    )
  }


  setLevelsListById(selectedLevel: any) {
    this.selectedlevel = selectedLevel
    console.log(this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel.Id);
  }






  // changeLevel(selectedlevel: any) {
  //   this.selectedlevel = selectedlevel;
  //   console.log(this.selectedlevel);
  //   this.GetLevelStandardSectionMapping(this.selectedlevel);
  //  };


  changeGrade(selectedGrade: any) {
    this.selectedGrade = selectedGrade;
    console.log("selectedgrade",this.selectedGrade)
    this.ShowSubjectSectionMapping(this.selectedlevel.Id,this.selectedGrade.standardId);

  };

  //-----------------------------------------------------

  private getLevelClassSection(lid) {
    this.dataAnalyticsService
      .GetLevelStandardSectionMapping(lid)
      .finally(() => {})
      .subscribe(
        (response) => {
          let mappedData: any = response;
          mappedData.forEach((standard) => {
            standard["Sections"].forEach((section) => {
              section["StdId"] = standard["standardId"];
              section["StdName"] = standard["standardsName"];
              section["selected"] = false;
            });
          });
          console.log("mappedData", mappedData);
          mappedData.sort((a, b) =>
            ("" + a.standardsName).localeCompare(b.standardsName, undefined, {
              numeric: true,
            })
          );
          if (true) {
            this.mappedData = mappedData;
          }
          try {
            this.selectedGrade = 'Select Grade';
          } catch (error) {
            //window.location.reload();
          }
        },
        (error) => {
          this.mappedData = [];
        }
      );
  }


  private getLevelsListById(level){
    console.log("getLevelsListById", level);
    this.getLevelClassSection(level["Id"]);
  }
  private getLevels() {
    this.dataAnalyticsService.GetLevels()._finally(() => {this.loading= "none"}).subscribe(
      response => {
        console.log("getLevels", response);
        this.LevelsData = response;
        try {
          this.selectedLevels = this.LevelsData[0];
          this.getLevelClassSection(this.selectedLevels["Id"]);
        } catch (error) {

        }
      }
    );
  }

  addSubject() {
    this.AddSubjectsModel = new addSubjectsModel();
    //for clearing checkbox
    this.mappedData.forEach(element => {
      element.checkFlag = false;
      this.selectedStd.push(element);
      console.log(element);
    });
    this.Es = false;
    this.Gs =false;
    this.selectedStd.forEach(element => {
      // console.log(element)
      element.selectedFlag = false;
      this.selectedStd.forEach(element1 => {
        element1.Sections.forEach(element2 => {
          element2.selected = false;
        });
      });
    });
    this.display = "block"
    this.selectedStd = [];
    // this.display = true;
  }
  onCloseHandled() {
    this.display = "none";
  }

  // new post Subjects
  public postSubjects() {
    console.log('AddSubjectsModel', this.AddSubjectsModel)
    // if (this.AddSubjectsModel.Name == undefined || this.AddSubjectsModel.Name == '' || this.guru.length == 0) {
    // alert('Please Fill All The Fields');
    // } else {

    this.AddSubjectsModel.SchoolId = this.schoolId;
    this.postSubjectsSections()

    // this.dataAnalyticsService.postSubject(this.AddSubjectsModel).finally(() => { }).subscribe(
    //   response => {
    //      console.log(response)
    //     this.Subjectid = response["id"];
    //     this.Subjectname = response["Name"];
    //     this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Subjects Added Successfully' });
    //     this.display = "none";
    //     // this.getSubjects();
    //     this.ShowSubjectSectionMapping(this.selectedlevel.Id,this.selectedGrade.standardId);
    //   },
    //   error => { }
    // );
    // }
  }


  private postSubjectsSections() {

    this.mappedData.map(element => {
      element.checkFlag = true;
      element.selectedFlag = false;
      if (Array.isArray(element['Sections'])) {
        element['Sections'].forEach(e => {
          e['selected'] = true;
          this.selectedStd = [];
          // console.log(e)
          this.guru.push(
            {
              "SectionName": e.sectionName,
              "SectionId": e.SectionId,
            }
          )
        });
      }
    });


    var obj = {
      "Schoolid": this.schoolId,
      "sectionidlist": this.guru,
      "Id": this.schoolId,
      "Name": this.AddSubjectsModel.Name,
      "BranchId": this.BranchId,

    }

    this.payload = obj;

    console.log("payload", this.payload)
    this.dataAnalyticsService.PostSubjectSectionMapping(this.payload).finally(() => { }).subscribe(
      response => {
        console.log(response)
        var value = response['Message'];
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Subjects Added Successfully' });
        this.display = "none";
        // this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Subjects Added Successfully' });
        // this.display = "none";
        // this.getSubjects();
        this.ShowSubjectSectionMapping(this.selectedlevel.Id,this.selectedGrade.standardId);
        // console.log(response)
        this.guru = [];
        this.payload = [];
      },
      error => { }
    );
  }

  // private getSubjects() {
  //   this.dataAnalyticsService.getSubjectsOfSubjects()._finally(() => { }).subscribe(
  //     response => {
  //       this.data = response;
  //       console.log('subject', this.data)
  //     }
  //   )
  // }



  private ShowSubjectSectionMapping(selectedlevel: any, selectedGrade:any ) {
    this.dataAnalyticsService.ShowSubjectSectionMappingaddsubject(selectedlevel,selectedGrade)._finally(() => { }).subscribe(
      response => {
        console.log(response);
        this.ShowSubjectSecData = response['Value'];
        this.collection = this.ShowSubjectSecData.length;
        console.log('ShowSubjectSecData', this.ShowSubjectSecData)
      }
    )
  }

  /*private ShowSubjectSectionMapping() {
    this.dataAnalyticsService.showSubjectSectionMapping()._finally(() => { }).subscribe(
      response => {
        console.log(response);
        this.ShowSubjectSecData = response['Value'];
        console.log('ShowSubjectSecData', this.ShowSubjectSecData)

      }
    )
  }*/


  edit() {
    this.ShowSubjectSecData.forEach(ele => {
      console.log(ele)
      ele.Standards.forEach(standardArr => {
        standardArr.Sections.forEach(element1 => {
          element1.selected = true;
        });
        // standardArr['selected'] = true;
        // this.modifiedSingleStd(true, ele.SubjectId, standardArr.StandardId, null, standardArr.StandardName, standardArr.Sections);
      });
    });
  }

  selectSingleStd(e, standardId, standardsName) {
    this.Gs = true;
    this.selectAllSectionFlag = false;
    this.Gs = false;
    if (e.target.checked) {
      this.mappedData.forEach(element => {
        if (element.standardsName == standardsName) {
          this.selectedStd.push(element)
        }
        // console.log(element)
      });
    }
    else {
      this.selectedStd.forEach(g => {
        g.Sections.forEach(element1 => {
          if (element1.StdName == standardsName) {
            element1.selected = true;
          }
        });
      });
      this.selectedStd = this.selectedStd.filter(m => m.standardsName != standardsName);
      if (this.selectedStd.length == 0) {

      }
    }

  }

  // modifiedSingleStd(isSelected, subjectId, standardId, sectionId, standardName, sectionArr) {
  //   sectionArr.map(ele => {
  //     ele.selected = true
  //   });
  //   console.log('sec', sectionArr)
  //   var selectedStd = {
  //     standardsName: standardName,
  //     selectedFlag: true,
  //     Sections: sectionArr
  //   }
  //   this.selectedStd.push(selectedStd);
  //   var result = this.selectedStd.reduce((unique, o) => {
  //     if (!unique.some(obj => obj.standardsName === o.standardsName)) {
  //       unique.push(o);
  //     }
  //     return unique;
  //   }, []);
  //   this.selectedStd = result;
  //   console.log('selectedStd', this.selectedStd)
  //   console.log('result', result)



  // }

  // editSubject(sub) {
  //   console.log(sub)
  //   this.ShowSubjectSecData.filter(ele => {
  //     if (ele.SubjectId == sub.SubjectId) {
  //       this.AddSubjectsModel.Name = sub.SubjectName;
  //       this.AddSubjectsModel.Id = sub.SubjectId;
  //       this.subName = sub.SubjectName;
  //       this.subId = sub.SubjectId;
  //       this.display1 = "block";
  //     }
  //   })

  // console.log(sub);
  // console.log(this.mappedData);
  // sub['Standards'].forEach(ele=> {
  //   console.log(ele);
  //   this.showdata = ele;
  //   console.log(this.showdata);
  // });
  // this.mappedData.forEach(element => {
  //   if (this.showdata['Sections'].filter(w => w.SectionId == element.SectionId).length > 0){
  //     element['selected'] = true;
  //   } else {
  //     element['selected'] = false;
  //   }
  // });
  // }

  editsubSubject(sub) {
    console.log(sub)
    this.selectedStd = [];
    this.ShowSubjectSecData.filter(ele => {
      if (ele.SubjectId == sub.SubjectId) {
        this.AddSubjectsModel.Name = sub.SubjectName;
        this.AddSubjectsModel.Id = sub.SubjectId;
        this.subName = sub.SubjectName;
        this.subId = sub.SubjectId;
        this.display1 = "block";
      }
    });

    //added code for edit checkbox
    this.mappedData.forEach(element => {
      if (sub["Standards"].filter(w => w.StandardId == element.standardId).length > 0) {
        element.checkFlag = true;
        this.selectedStd.push(element)

      } else {
        element.checkFlag = false;
      }
    });

    // console.log(this.mappedData)
    this.selectedStd.forEach(element => {
      console.log(element)
      if (sub["Standards"].filter(w => w.StandardId == element.standardId).length > 0) {
        element.selectedFlag = true;
        this.selectedStd.forEach(element1 => {
          element1.Sections.forEach(element2 => {
            element2.selected = true;
          });
        });

      } else {
        element.selectedFlag = false;
        this.selectedStd.forEach(element1 => {
          element1.Sections.forEach(element2 => {
            element2.selected = true;
          });
        });
      }
    });


  }


  onCloseHandled1() {
    this.display1 = "none";
  }

  // new updateSubject Subjects
  public UpdateSubjects() {
    this.AddSubjectsModel.SchoolId = this.schoolId;
    // this.AddSubjectsModel.Id = this.Subjectid;
    // this.AddSubjectsModel.Name = this.Subjectname;
    this.dataAnalyticsService.updateSubject(this.AddSubjectsModel).finally(() => { }).subscribe(
      response => {
        // console.log(response)
        var value = response['Message'];
        if (value == 'Subject updated successfully') {
          this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: value });
        } else
        if (value == 'Subject is already mapped to a section') {
          this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: value });
        }
        else
        if (value == 'Subject not updated') {
          this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: value });
        }
        // this.UpdateSubjectsSections()
        // this.dataAnalyticsService.PostSubjectSectionMapping(this.payload).finally(() => { }).subscribe(
        //   response => {
        //     var value = response['Message'];
        //     if (value == 'Subject Sections mapped/updated succesfully') {
        //       this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: value });
        //     }
        //     this.ShowSubjectSectionMapping();
        //     // console.log(response)
        //   },
        //   error => { }
        // );

        this.display1 = "none";
        // this.getSubjects();
        this.ShowSubjectSectionMapping(this.selectedlevel.Id,this.selectedGrade.standardId);
        console.log(response)
      },
      error => { }
    );
  }

  private UpdateSubjectsSections() {
    var obj = {
      "SubjectName": this.subName,
      "SubjectId": this.subId,
      "Sections": this.guru
    }
    // console.log(obj)

    this.payload = obj;

    console.log("payload", this.payload)
    this.dataAnalyticsService.PostSubjectSectionMapping(this.payload).finally(() => { }).subscribe(
      response => {
        var value = response['Message'];
        if (value == 'Subject Sections mapped/updated succesfully') {
          this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: value });
        }
        // this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Subjects Added Successfully' });
        // this.display = "none";
        // this.getSubjects();
        this.ShowSubjectSectionMapping(this.selectedlevel.Id,this.selectedGrade.standardId);
        // console.log(response)
        this.guru = [];
        this.payload = [];
      },
      error => { }
    );
  }


  confirm(Id) {
    console.log(Id)
    // this.DeleteSubjects(Id);
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        this.DeleteSubjects(Id);
      }
    });
  }

  public DeleteSubjects(Id) {
    this.dataAnalyticsService.DeleteSubjects(Id).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Subjects Deleted Successfully' });
        // this.getSubjects();
        this.ShowSubjectSectionMapping(this.selectedlevel.Id,this.selectedGrade.standardId);
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Subject is already mapped to a section' });
      }
    )
  }

  // editSubjectSec(sub) {
  //   alert()
  // }

  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);
      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, 'result');
    })
  }
  //All data
  private getClassSection() {
    this.noticeboardService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        // console.log('mappeddata',mappedData)
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (this.adminUserFlag) {
          this.mappedData = mappedData;
          // this.priorityFlag = true;
        }
        else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }
      },
      error => {
      });
  };


  verify(e) {
    if (e.target.checked) {
      this.payload = [];
      this.guru = [];
      this.selectAllSectionFlag = false;
      this.mappedData.map(element => {
        element.checkFlag = true;
        element.selectedFlag = false;
        if (Array.isArray(element['Sections'])) {
          element['Sections'].forEach(e => {
            e['selected'] = true;
            this.selectedStd = [];
            // console.log(e)
            this.guru.push(
              {
                "SectionName": e.sectionName,
                "SectionId": e.SectionId,
              }
            )
          });
        }
      });

    } else {
      this.payload = [];
      this.guru = [];
      this.mappedData.forEach(element => {
        element.checkFlag = false;
        if (Array.isArray(element['Sections'])) {
          element['Sections'].forEach(e => {
            e['selected'] = false;
            element.checkFlag = false;
          });
        }

      });
      console.log(this.payload)
    }

  }

  // new post SubjectsSectionMapping
  // public postSubjectsSections() {
  //   this.dataAnalyticsService.PostSubjectSectionMapping(this.payload).finally(() => { }).subscribe(
  //     response => {
  //       this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Subjects Added Successfully' });
  //       this.display = "none";
  //       this.getSubjects();
  //       this.ShowSubjectSectionMapping();
  //       console.log(response)
  //     },
  //     error => { }
  //   );
  // }

  //selecting a single grade
  // selectSingleStd(e, standardId, standardsName) {
  //   this.Gs = true;
  //   this.selectAllSectionFlag = false;
  //   this.Gs = false;
  //   if (e.target.checked) {
  //     this.mappedData.forEach(element => {
  //       if (element.standardsName == standardsName) {
  //         this.selectedStd.push(element)
  //       }

  //     });
  //   }
  //   else {
  //     this.selectedStd.forEach(g => {
  //       g.Sections.forEach(element1 => {
  //         if (element1.StdName == standardsName) {
  //           element1.selected = false;
  //         }
  //       });
  //     });
  //     this.selectedStd = this.selectedStd.filter(m => m.standardsName != standardsName);
  //     if (this.selectedStd.length == 0) {

  //     }
  //   }
  // }

  // for schoolUserFlag
  selectSingleStd1(e, standardId, standardsName) {
    this.Gs = true;
    this.selectAllSectionFlag = false;
    this.Gs = false;
    if (e.target.checked) {
      this.newSectionArray.forEach(element => {
        if (element.standardsName == standardsName) {
          this.selectedStd1.push(element)
        }
      });
    }
    else {
      this.selectedStd1.forEach(g => {
        g.Sections.forEach(element1 => {
          if (element1.StdName == standardsName) {
            element1.selected = false;
          }
        });
      });
      this.selectedStd1 = this.selectedStd1.filter(m => m.standardsName != standardsName);
      if (this.selectedStd1.length == 0) {

      }
      // if (Array.isArray(this.parentsList)) {
      //     this.parentsList = this.parentsList.filter(parentsList => parentsList.Standard !== standardsName);
      // }
    }
  }
  // grade selectall for schoolUserFlag
  // stdSelectall(e) {
  //   // this.parentsList;
  //   this.selectedStd1 = [];
  //   if (e.target.checked) {
  //     this.selectAllSectionFlag = true;
  //     this.newSectionArray.map(element => {
  //       element.checkFlag = true;
  //       element.selectedFlag = false;
  //       this.selectSingleStd1(e, element.standardId, element.standardsName)
  //     });

  //   } else {
  //     this.newSectionArray.forEach(element => {
  //       element.Sections.forEach(element1 => {

  //         element1.selected = false;

  //       });
  //       element.checkFlag = false;
  //       element.selectedFlag = false;
  //       this.selectSingleStd1(e, element.standardId, element.standardsName)
  //     });
  //     this.selectAllSectionFlag = false;
  //   }
  // }

  // for admin
  selectAllSection(e) {
    console.log("selectAllSection", e);
    if (e.target.checked) {
      // this.guru = [];
      // this.payload = [];
      this.selectAllSectionFlag = true;
      this.selectedStd.map(element => {
        element.selectedFlag = true;
        this.selectParentAll(e, element.standardsName, element);
        // element.Sections.forEach(e1 =>{
        //   this.guru.push(
        //     {
        //       "SectionName": e1.sectionName,
        //       "SectionId": e1.SectionId,
        //     }
        //   )

        //   // console.log(this.guru)

        //   var obj = {
        //     "SubjectName": this.subName,
        //     "SubjectId": this.subId,
        //     "Sections": this.guru
        //   }
        //   // console.log(obj)

        //   this.payload = obj;
        //   console.log(this.payload)
        //   // console.log(element)
        // })


      });

    } else {
      // this.guru = [];
      // this.payload = [];
      this.selectedStd.map(element => {
        element.selectedFlag = false;
        this.selectParentAll(e, element.standardsName, element);
      });
      this.selectAllSectionFlag = false;
      console.log(this.payload)
    }
  }

  selectParentAll(e, standardName, std) {
    if (e.target.checked) {
      // this.guru = [];
      // this.payload = [];
      this.mappedData.forEach(element => {
        if (element.standardsName == standardName) {
          element.Sections.forEach(childElement => {
            childElement.selected = true;
            this.check(e, childElement.StdName, childElement.sectionName, childElement.SectionId, childElement)

            // this.guru.push(
            //   {
            //     "SectionName": childElement.sectionName,
            //     "SectionId": childElement.SectionId,
            //   }
            // )

            // // console.log(this.guru)

            // var obj = {
            //   "SubjectName": this.subName,
            //   "SubjectId": this.subId,
            //   "Sections": this.guru
            // }
            // // console.log(obj)

            // this.payload = obj;
            // console.log(this.payload)
            // console.log(childElement)
          });
        }
      });
      // console.log(this.parentsList)
    }
    else {
      // this.guru = [];
      // this.payload = [];
      this.selectAllSectionFlag = false;
      this.mappedData.forEach(element => {
        if (element.standardsName == standardName) {
          element.Sections.forEach(childElement => {
            childElement.selected = false;
            this.check(e, childElement.StdName, childElement.sectionName, childElement.SectionId, childElement)
          });
        }
      });
      console.log(this.payload)
    }

  }

  // check(e, stdName, secName, secId, section) {
  //   console.log(secId)
  //   this.mappedData.forEach(element => {
  //     element.Sections.forEach(innerelement => {
  //       if (innerelement.sectionName == secName) {
  //         if (innerelement.selected == true && e.target.checked) {
  //           this.selectSectionCount = + 1;
  //           this.sectionName = secName;
  //           this.standardName = secId;
  //           this.guru.push(
  //             {
  //               "SectionName": secName,
  //               "SectionId": secId,
  //             }
  //           )
  //           console.log(this.guru)
  //           var obj = {
  //             "SubjectName": this.subName,
  //             "SubjectId": this.subId,
  //             "Sections": this.guru
  //           }
  //           console.log(obj)

  //           this.payload = obj;
  //         } else {
  //           this.selectSectionCount = - 1;
  //           this.guru = this.guru.filter(guru => guru.SectionId !== secId  )
  //           console.log(this.guru)
  //           // if (Array.isArray(this.parentsList)) {
  //           //   this.parentsList = this.parentsList.filter(parentsList => parentsList.sectionId !== secId);
  //           // }
  //         }
  //       }
  //     });
  //   });
  // }

  // remove(grade){
  //   console.log(grade);
  //   console.log(this.mappedData);
  //   grade['Standards'].forEach(ele=> {
  //     console.log(ele);
  //     this.showdata = ele;
  //     console.log(this.showdata);
  //   });
  //   this.mappedData.forEach(element => {
  //     if (this.showdata['Sections'].filter(w => w.SectionId == element.SectionId).length > 0){
  //       element['selected'] = true;
  //     } else {
  //       element['selected'] = false;
  //     }
  //   });

  // }




  check(e, stdName, secName, secId, section) {
    console.log(e)
    if (e.target.checked) {
      // this.guru =[];
      // this.payload =[];
      this.mappedData.forEach(element => {
        element.Sections.forEach(element1 => {
          if (element1.SectionId == secId) {
            element1.selected = true;
            console.log(element1)
            this.guru.push(
              {
                "SectionName": secName,
                "SectionId": secId,
                "selected": true,
              }
            )
            // console.log(this.guru)

            // var obj = {
            //   "SubjectName": this.Subjectname,
            //   "SubjectId": this.Subjectid,
            //   "Sections": this.guru
            // }
            // // console.log(obj)

            // this.payload = obj;
            console.log(this.payload)
          }
          // console.log(element1)
          // this.guru1.push(element1)
          // console.log(this.guru1)
        });
      });
    }
    else {
      // this.guru =[];
      // this.payload =[];
      this.guru.forEach(element => {
        if (element.SectionId == secId) {
          element.selected = false;
          this.guru = this.guru.filter(m => m.SectionId != secId);
        }
        // console.log(this.guru)
        // var obj = {
        //   "SubjectName": this.Subjectname,
        //   "SubjectId": this.Subjectid,
        //   "Sections": this.guru
        // }
        // // console.log(obj)

        // this.payload = obj;
        // console.log(this.payload)

      });

    }
    // this.guru1 = this.guru1.filter(m => m.SectionId != secId);
    // console.log(this.guru1)
  }

  //for schooluserFlag
  selectAllSection1(e) {
    if (e.target.checked) {
      // this.guru = [];
      // this.payload = [];
      this.selectAllSectionFlag = true;
      this.selectedStd1.map(element => {
        element.selectedFlag = true;
        this.selectParentAll1(e, element.standardsName, element);

        // element.Sections.forEach(e1 =>{
        //   this.guru.push(
        //     {
        //       "SectionName": e1.sectionName,
        //       "SectionId": e1.SectionId,
        //     }
        //   )

        //   // console.log(this.guru)

        //   var obj = {
        //     "SubjectName": this.subName,
        //     "SubjectId": this.subId,
        //     "Sections": this.guru
        //   }
        //   // console.log(obj)

        //   this.payload = obj;
        //   console.log(this.payload)
        //   // console.log(element)
        // })
      });

    } else {
      // this.guru = [];
      // this.payload = [];
      this.selectedStd1.map(element => {
        element.selectedFlag = false;
        this.selectParentAll1(e, element.standardsName, element);
      });
      this.selectAllSectionFlag = false;
    }
  }

  selectParentAll1(e, standardName, std) {

    if (e.target.checked) {
      // this.guru = [];
      // this.payload = [];
      // this.isAllSectionsSelected = true;
      this.newSectionArray.forEach(element => {
        if (element.standardsName == standardName) {
          element.Sections.forEach(childElement => {
            childElement.selected = true;
            this.check1(e, childElement.StdName, childElement.sectionName, childElement.SectionId, childElement)
          });
        }
      });
      // console.log(this.parentsList)
    }
    else {
      // this.guru = [];
      // this.payload = [];
      this.selectAllSectionFlag = false;
      this.newSectionArray.forEach(element => {
        if (element.standardsName == standardName) {
          element.Sections.forEach(childElement => {
            childElement.selected = false;
            this.check1(e, childElement.StdName, childElement.sectionName, childElement.SectionId, childElement)
          });
        }
      });
    }

  }

  // check1(e, stdName, secName, secId, section) {
  //   this.newSectionArray.forEach(element => {
  //     element.Sections.forEach(innerelement => {
  //       if (innerelement.sectionName == secName) {
  //         if (innerelement.selected == true && e.target.checked) {
  //           this.selectSectionCount = + 1;
  //           this.sectionName = secName;
  //           this.standardName = stdName;
  //         } else {

  //           this.selectSectionCount = - 1;

  //         }
  //       }

  //     });

  //   });
  // }


  check1(e, stdName, secName, secId, section) {
    console.log(e)
    if (e.target.checked) {
      // this.guru =[];
      // this.payload =[];
      this.newSectionArray.forEach(element => {
        element.Sections.forEach(element1 => {
          if (element1.SectionId == secId) {
            element1.selected = true;
            // console.log(element1)
            this.guru.push(
              {
                //"SectionName": secName,
                //"SectionId": secId,
                "sectionid": secId,
                "selected": true,
              }
            )
            // console.log(this.guru)

            // var obj = {
            //   "SubjectName": this.Subjectname,
            //   "SubjectId": this.Subjectid,
            //   "Sections": this.guru
            // }
            // // console.log(obj)

            // this.payload = obj;
            // console.log(this.payload)
          }
        });
      });
    }
    else {
      // this.guru =[];
      // this.payload =[];
      this.guru.forEach(element => {
        if (element.SectionId == secId) {
          element.selected = false;
          this.guru = this.guru.filter(m => m.SectionId != secId);
        }
        // console.log(this.guru)
        // var obj = {
        //   "SubjectName": this.Subjectname,
        //   "SubjectId": this.Subjectid,
        //   "Sections": this.guru
        // }
        // // console.log(obj)
        // this.payload = obj;
        // console.log(this.payload)
      });
    }
  }

  // View() {
  //   this.view = true;
  // }
  // HideView() {
  //   this.view = false;
  // }




}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/AddsubjectS/addSubjectsS.component.ts